var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6H10V3C9.9996 2.6023 9.84144 2.221 9.56022 1.93978C9.279 1.65856 8.8977 1.5004 8.5 1.5H7.4335C7.19308 1.50102 6.96098 1.5882 6.77934 1.74571C6.5977 1.90323 6.47855 2.12064 6.4435 2.3585L6.021 5.317L4.2325 8H1V15H11.5C12.4279 14.9987 13.3173 14.6295 13.9734 13.9734C14.6295 13.3173 14.9987 12.4279 15 11.5V8C14.9993 7.46977 14.7884 6.96145 14.4135 6.58652C14.0386 6.21159 13.5302 6.00066 13 6ZM4 14H2V9H4V14ZM14 11.5C13.9992 12.1628 13.7356 12.7982 13.2669 13.2669C12.7982 13.7356 12.1628 13.9992 11.5 14H5V8.6515L6.979 5.683L7.434 2.5H8.5C8.63261 2.5 8.75979 2.55268 8.85355 2.64645C8.94732 2.74021 9 2.86739 9 3V7H13C13.2651 7.0004 13.5192 7.10588 13.7067 7.29333C13.8941 7.48078 13.9996 7.73491 14 8V11.5Z",
    fill: "black",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeSelected);
export default __webpack_public_path__ + "static/media/likeSelected.bf303c83d5220cb1e6edcfa749bb58e9.svg";
export { ForwardRef as ReactComponent };